// Etape numerotee — rendu sur fond clair sky (#EAF4FB) dans WorkflowSection.
// Toutes les classes "sombres" (text-white, text-sky-muted, bg-white/10, border-accent/60) sont remplacees.
const StepCard = ({ number, title, desc }) => (
  <div className="relative z-10 text-center">
    {/* Cercle numero : fond marine translucide sur clair, bordure accent pleine */}
    <div className="w-16 h-16 mx-auto bg-primary-900/10 rounded-full flex items-center justify-center text-2xl font-display font-bold text-primary-900 border-2 border-accent mb-6 relative">
      {number}
      {/* Point indicateur : success-700 (#1aa78a) pour le contraste sur fond clair */}
      <div className="absolute top-0 right-0 w-3 h-3 bg-success-700 rounded-full"></div>
    </div>
    <h3 className="font-display font-bold text-lg text-primary-900 mb-2">{title}</h3>
    <p className="font-sans text-primary text-sm px-4">
      {desc}
    </p>
  </div>
);

export default StepCard;
